import {
  INewTicketAutRecRuleTasyOrientation,
  ITicketAutRecRuleTasyOrientation,
} from "../models/ticket-aut-rec-rule-tasy-orientation";
import { GlobalAxios } from "./../axios/axios-config";

const TICKET_AUT_REC_RULE_TASY_ORIENTATION_ROUTE =
  process.env.REACT_APP_AUTOMATIONS +
  "/api/v1/TicketAutRecRuleTasyOrientation/";

export const createTicketAutRecRuleTasyOrientation = (
  item: INewTicketAutRecRuleTasyOrientation
) => {
  return GlobalAxios.post(TICKET_AUT_REC_RULE_TASY_ORIENTATION_ROUTE, item);
};

export const getTicketAutRecRuleTasyOrientationById = (id: string) => {
  return GlobalAxios.get<ITicketAutRecRuleTasyOrientation>(
    TICKET_AUT_REC_RULE_TASY_ORIENTATION_ROUTE + id
  );
};

export const updateTicketAutRecRuleTasyOrientationById = ({
  item,
  id,
}: {
  item: INewTicketAutRecRuleTasyOrientation;
  id: string;
}) => {
  return GlobalAxios.put(TICKET_AUT_REC_RULE_TASY_ORIENTATION_ROUTE + id, item);
};
